<template>
  <div>
    <b-modal
      id="vouchers-modal"
      ref="vouchers-modal-ref"
      hide-footer
      title="Voucher Information"
    >
      <div>
        <div>
          <div>
            <span>{{ voucherInformation }}</span>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default: null,
    },
    voucherInformation: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  methods: {
    show() {
      this.$refs["vouchers-modal-ref"].show();
    },
  },
};
</script>

<style>
.voucher {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  padding: 5px;
}
.button {
  border: none;
  color: white;
  height: 35px;
  width: 15%;
}
</style>
